<template>
  <section>
    <div class="row align-items-center no-gutters">
      <div class="col-4 col-md-3">
        <img src="/static/img/brand-visa.svg"
              height="60"
              alt="visa"
              v-if="payment.brand === 'visa'">
        <img src="/static/img/brand-master-card.svg"
              height="60"
              alt="master card"
              v-else-if="payment.brand === 'mastercard'">
        <img src="/static/img/brand-jcb.svg"
              height="60"
              alt="jcb"
              v-else>
      </div>
      <div class="col-8 col-md-9">
        ●●●● {{ payment.last_digits }}<br>
          {{ payment.expire_month }} / {{ payment.expire_year }}
      </div>
    </div>
    <div class="text-remark -status-alert" v-if="payment.is_expired">({{ $t('message.booking.payment_step.card_is_expired') }})</div>
  </section>
</template>

<script>
  export default {
    props: ['payment']
  }
</script>



// WEBPACK FOOTER //
// src/components/payment/PaymentSmall.vue